import { useTranslation } from "react-i18next";
import { kaspreadsheetUrl } from "@/mocks/categories";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[500px] md:min-h-[550px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Beautiful%20product%20photography%20flat%20lay%20with%20assorted%20fashion%20items%20including%20sneakers%20hoodie%20cap%20and%20accessories%20arranged%20elegantly%20on%20a%20warm%20cream%20surface%2C%20soft%20diffused%20natural%20lighting%2C%20sophisticated%20editorial%20catalog%20style%2C%20neutral%20earthy%20tones%20with%20subtle%20olive%20accents%2C%20high%20end%20European%20aesthetic&width=1800&height=800&seq=cta-v2-4f9s6&orientation=landscape"
          alt="USFansSpreadsheet sklep"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-primary-500/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-16 py-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-lg">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 lowercase mb-4">
              {t("cta.title")}
            </h2>
            <p className="text-background-100/80 text-base md:text-lg leading-relaxed max-w-sm">
              {t("cta.description")}
            </p>
          </div>

          <a
            href={kaspreadsheetUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-between px-6 py-4 bg-background-50 text-foreground-950 text-base font-medium rounded-full hover:bg-background-100 transition-all cursor-pointer gap-4 self-start whitespace-nowrap"
          >
            <span>{t("cta.button")}</span>
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500">
              <i className="ri-arrow-right-line text-background-50 text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}